import React, { Component, FunctionComponent } from 'react'
import * as S from './styled'
import ArrowIcon from '../../atoms/ArrowIcon'
import { Direction } from '../../atoms/ArrowIcon/'
import { Label2, BoldText } from '../../../theme/typography'

type OwnProps = {
  label: string
  value: string | number
  direction?: Direction
  moreIsBad?: boolean
  icon?: Component
}

type Props = OwnProps
const identifiers = ['%', ' g', ' kr', ' kg', ' g/l', 'N/A', '']
const findIdentifier: Record<string, string> = {
  Knäck: identifiers[0],
  Smuts: identifiers[0],
  Frånsorterat: identifiers[0],
  Odugliga: identifiers[0],
  Medelvikt: identifiers[1],
  'Lev.Kvant.Kg': identifiers[3],
  Vattenhalt: identifiers[0],
  'Avrens %': identifiers[0],
  Rymdvikt: identifiers[4],
  Protein: identifiers[0],
  'Oljehalt %': identifiers[0],
  Klorofyll: identifiers[6],
  rest: ' kr',
}
export const SummaryCard: FunctionComponent<Props> = ({
  label,
  value,
  direction = Direction.UNCHANGED,
  moreIsBad,
  icon,
}) => {
  value = +value
  return (
    <S.Card>
      {icon ? icon : <ArrowIcon showBorder direction={direction} moreIsBad={moreIsBad} />}
      <S.Text>
        <Label2>{label}</Label2>
        <BoldText>
          {value > 0 ? value.toLocaleString('sv') : ''}
          {findIdentifier[label] === undefined ? findIdentifier['rest'] : findIdentifier[label]}
        </BoldText>
      </S.Text>
    </S.Card>
  )
}

export default SummaryCard
